export enum QuotationStatus {
  NEW = "new",
  INPROGRESS = "in progress",
  CONFIRMED = "confirmed",
  REJECTED = "rejected",
}

export enum QuotationOptionService {
  ECOMMERCE = "ecommerce_fulfillment",
  FREIGHTFORWARDING = "freight_forwarding"
}

export type FreightForwardingInputModel = {
  id: string;
  portOfLoading: string;
  portOfDischarge: string;
  modeOfTransport: string;
  modeOfService: string;
  commodity: string;
  numberOfSKU?: number,
  storage?: string;
  note?: string;
}

export type EcommerceFulfillmentInputModel = {
  id: string;
  orderPerMonth: string;
  itemsPerOrder: string;
  numberOfSKU: number;
  weightOfParcel: string;
  webshopPlatform?: string;
  storage: string;
  note?: string;
}

export type QuotationOutputModel = {
  id: string;
  code: string;
  fullName: string;
  email: string;
  phone: string;
  companyURL: string;
  address: string;
  service: string;
  status: QuotationStatus;
  createdAt: string;
  freight_forwarding: FreightForwardingOutputModel | null;
  ecommerce: EcommerceFulfillmentOutputModel | null;
}

export type QuotationExportExcelOutputModel = {
  id?: string;
  code: string;
  fullName: string;
  email: string;
  phone: string;
  companyURL: string;
  address: string;
  shipmentServices: string;
  service: string;
  status: QuotationStatus;
  createdAt: string;
  freight_forwarding?: FreightForwardingOutputModel | null;
  ecommerce?: EcommerceFulfillmentOutputModel | null;
}

export type FreightForwardingOutputModel = {
  id: string;
  quotationId: string;
  portOfLoading: string;
  portOfDischarge: string;
  modeOfTransport: string;
  modeOfService: string;
  commodity: string;
  numberOfSKU: number,
  storage: string;
  note: string;
}

export type EcommerceFulfillmentOutputModel = {
  id: string;
  quotationId: string;
  orderPerMonth: string;
  itemsPerOrder: string;
  numberOfSKU: number;
  weightOfParcel: string;
  webshopPlatform: string;
  storage: string;
  note: string;
}

export type QuotationHistoryOutputModel = {
  id: string;
  quotationId: string;
  action: string;
}